import React, { useState, useEffect } from 'react';
import apiClient from '../../../Api/axiosConfig';
import './DashboardPage.css';

const StatCard = ({ title, value, icon, isLoading }) => {
    return (
        <div className="stat-card">
            <div className="stat-card-icon">{icon}</div>
            <div className="stat-card-info">
                <span className="stat-card-title">{title}</span>
                <span className="stat-card-value">{isLoading ? '...' : value}</span>
            </div>
        </div>
    );
};

const DashboardPage = () => {
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        setIsLoading(true);
        apiClient.get('/dashboard/stats')
            .then(response => {
                setStats(response.data);
            })
            .catch(() => {
                setError('Hiba a statisztikák betöltésekor.');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div>
            <div className="admin-page-header">
                <h1>Áttekintés</h1>
            </div>

            {error && <p className="dashboard-error">{error}</p>}
            
            <div className="stats-grid">
                <StatCard 
                    title="Mai egyedi látogatók" 
                    value={stats?.todayVisitors} 
                    icon="👤" 
                    isLoading={isLoading}
                />
                <StatCard 
                    title="Mai letöltések (összes)" 
                    value={stats?.todayDownloads} 
                    icon="📥"
                    isLoading={isLoading}
                />
                <StatCard 
                    title="Havi egyedi látogatók" 
                    value={stats?.monthlyVisitors} 
                    icon="📅"
                    isLoading={isLoading}
                />
            </div>
            
            <div className="dashboard-welcome">
                <h2>Üdv az admin felületen!</h2>
                <p>Itt a legfontosabb mérőszámokat látod. A részletesebb beállításokért használj a bal oldali menüt.</p>
            </div>
        </div>
    );
};

export default DashboardPage;